const IPV4_PATTERN = /^\d{1,3}(?:\.\d{1,3}){3}$/

/** 去除端口、IPv6 方括号与末尾点，得到可用于 Cookie 判断的 hostname。 */
export function normalizeCookieHostname(host: string): string {
  const normalizedHost = host.trim().toLowerCase()

  if (!normalizedHost) {
    return ''
  }

  if (normalizedHost.startsWith('[')) {
    const closingBracketIndex = normalizedHost.indexOf(']')
    return closingBracketIndex > 0
      ? normalizedHost.slice(1, closingBracketIndex)
      : normalizedHost
  }

  const colonCount = normalizedHost.split(':').length - 1
  const hostname = colonCount === 1
    ? normalizedHost.split(':')[0]
    : normalizedHost

  return hostname.replace(/\.$/, '')
}

/** localhost 与 IP 地址必须使用 host-only Cookie，不能设置 Domain。 */
export function requiresHostOnlyCookie(host: string): boolean {
  const hostname = normalizeCookieHostname(host)

  return hostname === 'localhost'
    || hostname.endsWith('.localhost')
    || IPV4_PATTERN.test(hostname)
    || hostname.includes(':')
}

/**
 * 返回当前站点可共享给子域的 Cookie 域；本地地址和 IP 返回 undefined。
 */
export function resolveCookieDomain(host: string): string | undefined {
  const hostname = normalizeCookieHostname(host)

  if (!hostname || requiresHostOnlyCookie(hostname)) {
    return undefined
  }

  const labels = hostname.split('.').filter(Boolean)
  if (labels.length <= 2) {
    return hostname.replace(/^biz\./, '')
  }

  return labels.slice(-2).join('.')
}
